export const state = {
  // product: undefined,
  // products: []
  token: {},
  tokens: [],
  pagination:''
}
